import { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import ImageNotSupportedOutlinedIcon from '@mui/icons-material/ImageNotSupportedOutlined';
import { b2bColors } from '../styles/b2bTheme';

/**
 * Vignette produit du catalogue B2B.
 *
 * Tous les produits n'ont pas de photo (≈ 1/3 du catalogue actif) : on
 * garde une case de taille fixe avec un placeholder pour que les lignes
 * du tableau ne changent pas de hauteur selon la présence d'image.
 * Chargement `lazy` — 50 lignes par page.
 */
export default function ProductThumb({ src, alt = '', size = 44 }) {
    const [failed, setFailed] = useState(false);
    // Une image cassée ne doit pas condamner la vignette si la ligne est
    // réutilisée pour un autre produit (tri, pagination).
    useEffect(() => { setFailed(false); }, [src]);
    const showImage = Boolean(src) && !failed;

    return (
        <Box
            sx={{
                width: size,
                height: size,
                flexShrink: 0,
                borderRadius: 0.5,
                border: `1px solid ${b2bColors.border}`,
                backgroundColor: b2bColors.surfaceAlt,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                overflow: 'hidden',
                color: b2bColors.textDisabled,
            }}
        >
            {showImage ? (
                <Box
                    component="img"
                    src={src}
                    alt={alt}
                    loading="lazy"
                    onError={() => setFailed(true)}
                    sx={{ width: '100%', height: '100%', objectFit: 'contain' }}
                />
            ) : (
                <ImageNotSupportedOutlinedIcon fontSize="small" aria-hidden />
            )}
        </Box>
    );
}
